import { ExceptionService } from '../services/exception.service';
import { NodeAPIEntityService } from '../services/node.entity.service';
import { Component, Input, Output, EventEmitter, AfterContentChecked, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { UntypedFormGroup, UntypedFormControl, UntypedFormBuilder, Validators } from '@angular/forms';
import { TogetherDIPStageContainer } from './../models/app.models';
import { TogetherBaseAddress, TogetherAuctionDIPApplicantCompanyDetails, TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses } from './../models/api.models';
import { TogetherAuctionDIPEntityType, TogetherAuctionDIPEntityOperation } from './../models/enums';
import * as _ from 'lodash-es';

@Component({
    selector: 'together-auction-dip-applicant-company',
    templateUrl: './dip.applicant.company.component.html',
    providers: [NodeAPIEntityService],
    standalone: false
})
export class TogetherAuctionDIPApplicantCompanyComponent implements OnChanges, OnInit {
  tad_business_details_form: UntypedFormGroup;
  tad_company_name: UntypedFormControl = new UntypedFormControl(null, [
    Validators.required,
    Validators.minLength(3),
  ]);
  tad_company_address: UntypedFormGroup = new UntypedFormGroup({});
  @Input() do_delete: boolean;
  @Output() do_deleteChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() companyAddress: TogetherBaseAddress = new TogetherBaseAddress();
  @Input() incoming_case_id: string;
  @Input() business_applicant: TogetherAuctionDIPApplicantCompanyDetails;
  @Output() businesss_applicantChange: EventEmitter<TogetherAuctionDIPApplicantCompanyDetails>
    = new EventEmitter<TogetherAuctionDIPApplicantCompanyDetails>();
  @Input() doSaveBusinessApp: boolean = false;
  @Output() doSaveSuccess: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() hasPostCodeNotEntered: boolean;
  @Input() is_enabled: boolean = false;
  @Input() is_business: boolean = false;
  @Input() stage: TogetherDIPStageContainer;
  @Output() form_out: EventEmitter<UntypedFormGroup> = new EventEmitter<UntypedFormGroup>();
  @Output() updating_loading_status: EventEmitter<object> = new EventEmitter<object>();

  addresslookup: UntypedFormGroup = this.fb.group({});
  _isLoading: boolean = false;

  set isLoading(val: boolean) {
    if (this._isLoading === val) {
      return;
    }
    this.updating_loading_status.emit({
      component: 'businessApplicant',
      parameter: null, // There is only one business applicant.
      status: val,
    });
    this._isLoading = val;
  }

  /**
   * Handles the address returned by the address lookup component.
   *
   * @param {any} address
   * @memberof TogetherAuctionDIPApplicantCompanyComponent
   */
  _handleIncomingAddress(address) {
    this.companyAddress = address.address;
  }

  _handleIncomingForm(form) {
    this.tad_company_address = form;
  }

  _handleFormInit() {
    if (this.is_enabled) {
      this.tad_company_name = new UntypedFormControl(null, [Validators.required]);
      this.tad_business_details_form = this.fb.group({
        tad_company_name: this.tad_company_name,
        tad_company_address: this.tad_company_address,
        addresslookup: this.addresslookup,
      });

    } else {
      this.tad_business_details_form = this.fb.group({
        tad_company_name: this.tad_company_name,
        tad_company_address: this.fb.group({}),
        addresslookup: this.addresslookup,
      });
    }

    this.form_out.emit(this.tad_business_details_form);
  }


  _handleUpdateAPIObject() {
    if (_.isNil(this.business_applicant) === true) {
      this.business_applicant = new TogetherAuctionDIPApplicantCompanyDetails();
    }
    this.business_applicant.CompanyName = this.tad_company_name.value;
    var _addr = this.business_applicant.LegalBodyRoleAddresses[0];

    if (_.isNil(_addr) === true) {
      _addr = new TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses();
    }

    var addr = this.tad_company_address;
    if (_.isNil(addr.get('addressPostcode')) === false) {
      _addr.HouseName = _.defaultTo(addr.get('addressHouseName').value, '');
      _addr.HouseNumber = _.defaultTo(addr.get('addressHouseNumber').value, '');
      _addr.District = _.defaultTo(addr.get('addressDistrict').value, '');
      _addr.County = _.defaultTo(addr.get('addressCounty').value, '');
      _addr.Street = _.defaultTo(addr.get('addressStreet').value, '');
      _addr.Street1 = _.defaultTo(addr.get('addressStreet').value, '');
      _addr.Street2 = _.defaultTo(addr.get('addressStreet').value, '');
      _addr.PostTown = addr.get('addressTownCity').value;
      _addr.Postcode = addr.get('addressPostcode').value;
    }

    if (_.isArray(this.business_applicant.LegalBodyRoleAddresses) === false) {
      this.business_applicant.LegalBodyRoleAddresses = [];
    }

    this.business_applicant.LegalBodyRoleAddresses = [_addr];
  }

  _handleSaveBusinessApplicant() {
    this.isLoading = true;
    this.entity.saveEntities(TogetherAuctionDIPEntityType.ApplicantsBusiness,
      this.incoming_case_id, this.business_applicant.Id, this.business_applicant)
      .subscribe(
        (success: Object) => {
          this.isLoading = false;
          this.business_applicant = new TogetherAuctionDIPApplicantCompanyDetails(success);
          this.doSaveSuccess.emit(true);
        },
        (error) => {
          this.exception.haveReceivedError(error);
          this.isLoading = false;
          return;
        },
      );
  }

  _handleBindForm() {
    if (_.isNil(this.business_applicant) === true) {
      this.business_applicant = new TogetherAuctionDIPApplicantCompanyDetails();
    }

    this.tad_company_name.setValue(this.business_applicant.CompanyName);
    var address: TogetherAuctionDIPApplicantDetailsLegalBodyRoleAddresses =
      this.business_applicant.LegalBodyRoleAddresses[0];

    if (_.isNil(address) === true) {
      return;
    }
    this.hasPostCodeNotEntered = false;
    // Update address component
    this.companyAddress = address;
  }

  setDynamicClasses(control: string) {
    return {
      'is-invalid form-control-danger': this.tad_business_details_form.get(control).touched
        && this.tad_business_details_form.get(control).invalid,
      'is-valid form-control-success': this.tad_business_details_form.get(control).touched
        && this.tad_business_details_form.get(control).valid,
    };
  }

  setDynamicClassesForFormgroup(control: string) {
    return {
      'is-invalid': this.tad_business_details_form.get(control).touched
        && this.tad_business_details_form.get(control).invalid,
      'is-valid': this.tad_business_details_form.get(control).touched
        && this.tad_business_details_form.get(control).valid,
    };
  }

  ngOnInit() {
    this._handleBindForm();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (_.isNil(changes['doSaveBusinessApp']) === false) {
      if (changes['doSaveBusinessApp'].currentValue === true &&
        changes['doSaveBusinessApp'].previousValue === false) {
        this._handleSaveBusinessApplicant();
      }
    }
    this.form_out.emit(this.tad_business_details_form);
  }

  ngAfterContentChecked() {
    this._handleFormInit();
    this._handleUpdateAPIObject();
    this.form_out.emit(this.tad_business_details_form);
  }

  constructor(private fb: UntypedFormBuilder,
    private entity: NodeAPIEntityService,
    private exception: ExceptionService) {
    this._handleFormInit();
  }

}
